import React from 'react'

import MyQuizTemplatesAvailableCategories from './MyQuizTemplatesAvailableCategories'
import MyQuizTemplatesList from './MyQuizTemplatesList'
import MyQuizTemplatesSuccessModal from './MyQuizTemplatesSuccessModal'
import MyQuizTemplatesEditSuccessModal from './MyQuizTemplatesEditSuccessModal'

import { useAvailableCategories } from '../../../../../hooks'

const MyQuizTemplates = () => {
  const { passedCategories } = useAvailableCategories('passed')

  return (
    <div className="w-full pb-16">
      <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-[20px] text-primary-100">
        Quiz Template Settings
      </h3>

      <MyQuizTemplatesAvailableCategories passedCategories={passedCategories} />
      <MyQuizTemplatesList passedCategories={passedCategories} />

      <MyQuizTemplatesSuccessModal />
      <MyQuizTemplatesEditSuccessModal />
    </div>
  )
}

export default MyQuizTemplates
